import { httpRequest } from '../../../../app/common/util/api-common.util';

class MacroscopiaAPI {
  static getDetalhesMacro(laudo) {
    return httpRequest(`laudos/${laudo}/etapas/macro/detalhes`).then(
      (json) => json.data
    );
  }

  static getRtfMacro(laudo) {
    return httpRequest(`laudos/${laudo}/etapas/macro/rtf`);
  }

  static atualizarTextoMacro(laudo, texto) {
    return httpRequest(`laudos/${laudo}/etapas/macro/rtf`, 'PATCH', {
      texto: texto,
    }).then((json) => json.data);
  }

  static cancelamentoMacro(laudo, justificativa) {
    return httpRequest(`laudos/${laudo}/etapas/macro/cancelamento`, 'PATCH', {
      justificativa: justificativa,
    }).then((json) => json.data);
  }

  static getProtocolo() {
    return httpRequest('recebimentomaterial/protocolo');
  }

  static getCentroResponsabilidade() {
    return httpRequest('recebimentomaterial/centroresponsabilidade');
  }

  static getCestas() {
    return httpRequest('recebimentomaterial/cestas');
  }

  static getMaterial() {
    return httpRequest('materiais')
      .then(json => json.data);
  }
}

export default MacroscopiaAPI;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/macroscopia/macroscopia.api.js